import React from 'react'
import { VM_Colors } from '../../Styles/VMStyles';
import { Box, Typography } from '@mui/material';

function MuiTypographyMandatory(props) {
  const {label,required} = props;
  
  return (
  <Box
    sx={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <Typography
          // sx={{
          //   fontFamily: "Lato",
          //   fontWeight: 400,
          //   fontSize: "16px",
          //   lineHeight: "24px",
          //   color: "#000000",
          // }}
          sx={{  fontWeight: 500 }}
          {...props}
        >
          {label}
        </Typography>
        {required && (
          <Typography
            sx={{
              fontFamily: "Lato",
              fontWeight: 400,
              fontSize: "12px",
              lineHeight: "18px",
              color: VM_Colors.error,
              ml: 1,
            }}
          >
            *
          </Typography>
        )}
      </Box>
  )
}

export default MuiTypographyMandatory